<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-12 09:49:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-30 16:09:04
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 14:08:44
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-10 15:19:17
-->
<template>
   <div class="org-box">
      <div class="table-box">
    <el-table
      :data="tableData"
      row-key="id"
      style="width: 100%"
       ref="sortTable"
       :height="sortTableHeight"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column width="500"  prop="name" label="站点名称"> </el-table-column>
      <el-table-column width="120"  prop="id" label="站点ID"> </el-table-column>
      <el-table-column width="300" prop="domain" label="访问域名"> </el-table-column>
      <el-table-column width="200" prop="folder" label="站点目录"> </el-table-column>
      <el-table-column width="120" prop="flagDisable" label="站点状态">
         <template slot-scope="scope">
              {{scope.row.flagDisable?'停用':'启用'}}
        </template>
      </el-table-column>
      <el-table-column width="120" prop="sort" label="排序">
        <template slot-scope="scope">
          <div class="sort">
            <div   class="sort-box">
               <div  class="sort-two" v-if="codeData.indexOf('230') != -1" @click="upFn(scope.row)">
                    <i   class="ri-arrow-up-line"></i>
                </div>
            </div>
            <input disabled v-model="scope.row.sort" class="sort-style" />
            <div class="sort-box-two">
              <div  class="sort-two" v-if="codeData.indexOf('231') != -1" @click="downFn(scope.row)">
                   <i  class="ri-arrow-down-line"></i>
                </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
           <div style="display: flex;padding-left:20px">
                 <div class="btnTwo" style="margin-right: 20px" v-if="codeData.indexOf('143') != -1" @click="editAdmin(scope.row)">编辑</div>
                  <div
                    @click="open(scope.row)"
                    class="btnThree"
                    v-if="scope.row.parentId!=0 && codeData.indexOf('144') != -1"
                    >删除</div
                  >
           </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="确认删除站点?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      :before-close="handleClose"
      custom-class="tips-box"
      top="17%"
    >
      <span
        >站点删除是不可逆的操作，若确需删除，请在下方输入框中输入站点名称后在点击"确认删除"按钮</span
      >
      <el-input
        class="delete-input"
        v-model="input"
        placeholder="请输入确需删除的站点名称"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button type="danger" @click="deleteFn">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
   </div>
</template>

<script>
import { up, down, deleteSite } from "./station_group_management";
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      dialogVisibleTwo: false,
      input: "",
      item: {},
      codeData:[],
       sortTableHeight: 800,
    };
  },
  props: ["tableData"],
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.$nextTick(function () {
        let exceptHeight = 260;
        // this.$refs.table.$el.offsetTop：表格距离浏览器的高度
        if (this.$refs.sortTable.$el) {
          this.sortTableHeight =
            window.innerHeight -
            this.$refs.sortTable.$el.offsetTop -
            exceptHeight;
        }

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          if (self.$refs.sortTable.$el) {
            self.sortTableHeight =
              window.innerHeight -
              self.$refs.sortTable.$el.offsetTop -
              exceptHeight;
          }
        };
      });
    },
    handleClose() {
        this.dialogVisibleTwo = false;
        this.input = "";
    },
    upFn(item) {
      up({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.$emit("move");
        }
      });
    },
    downFn(item) {
      down({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.$emit("move");
        }
      });
    },
    deleteFn() {
      if (this.input == this.item.name) {
        deleteSite({
          id: this.item.id,
        }).then((res) => {
          if (res.code == 0) {
            this.$emit("move");
            this.dialogVisibleTwo = false;
             this.input = "";
          }
        });
      }else{
         this.dialogVisibleTwo = false;
        message.error('输入站点名称不正确');
      }
    },
    editAdmin(item) {
      this.$emit("editAdmin", item);
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisibleTwo = true;
    },
    addAdminFn() {
      this.$emit("addAdminFn");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__body {
  color: #000;
}
/deep/ .has-gutter {
  color: #000;
  font-weight: 800;
}
/deep/ .el-table__header {
  th {
    background: #f7f7f7 !important;
    height: 60px;
  }
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.table-box {
  position: relative;
  width: 100%;
  padding: 0px;
 /deep/ .el-table {
    position: absolute;
    width: 100%;
  }
}
/deep/ .el-table__body{
  width: 100% !important;
}
/deep/ .el-table__header{
  width: 100% !important;
}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
.delete-input {
  margin-top: 24px;
}
/deep/ .el-dialog__footer {
  padding-top: 0px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .el-icon-arrow-right {
  font-size: 18px;
  color: #a9aab1;
}

/deep/ .el-table .el-table__expand-icon {
  .el-icon-arrow-right:before {
    content: "\e791";
  }
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.org-box {
  padding: 24px;
}
/deep/ .el-table__fixed-right{
    border-left: 1px solid rgba(228, 231, 237, 1);
} 
/deep/ .el-table th.el-table__cell>.cell{
    color: #606266;
} 
/deep/ .el-table__fixed-right-patch{
  width: 0px !important;
  height: 0px !important;
}
/deep/ .el-table__header th:last-child{
  padding-left: 20px;
}
/deep/ .el-table__body{
  color: #303133 !important;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/deep/ .el-table__header {
  th {
    background-color: rgba(245, 247, 250, 1) !important;
    height: 48px;
  }
}
/deep/ .el-table td.el-table__cell{
     height: 48px;
     padding: 0;
}
/deep/ .el-table__body tr:hover>td{
  background-color: #fafafa !important;
}
/deep/ .el-table__body tr.hover-row >td.el-table__cell{
  background-color: #fafafa !important;
}
/deep/ .el-table__footer-wrapper, .el-table__header-wrapper{
  overflow: scroll !important;
}
.sort-two{
   display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
</style>